import { CreatableSelect } from '@oy/uidesktop';
import { filter, first } from 'lodash-es';
import { DEV_SERVERS } from 'src/constants';
import { useDevConfigFormImpl } from './useDevConfigFormImpl';

export const DevConfigForm = () => {
  const { onValueChanged, state } = useDevConfigFormImpl();
  const { data } = state;
  return (
    <div>
      <CreatableSelect
        label="Server"
        isHorizontal
        options={DEV_SERVERS}
        value={first(filter(DEV_SERVERS, e => e.value === data?.value))}
        onChange={e => onValueChanged(e?.value, e?.label)}
        onCreateOption={(e: any) =>
          DEV_SERVERS.push({
            value: e,
            label: e,
          })
        }
      />
    </div>
  );
};
